import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'app-topbar',
  standalone: true,
  templateUrl: './topbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  readonly videoTitle = input<string | undefined>('');
}
